import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "pastsurgical-information-modal",
    templateUrl: "./pastsurgical-information-modal.component.html",
    styleUrls: ["./pastsurgical-information-modal.component.scss"],
})
export class PastSurgicalInformationModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    @Input() SummaryData: any;
    @Output() readonly Response: EventEmitter<any> = new EventEmitter();
    error = "";
    public checklist: Array<any> = [];
    public others: string = "";

    ngOnInit() {
        this.checklist = [
            {
                name: "Adenoidectomy",
                value: false,
            },
            {
                name: "Appendectomy",
                value: false,
            },
            {
                name: "Bariatric",
                value: false,
                subset: [
                    {
                        name: "Gastric Bypass",
                        value: false,
                    },
                    {
                        name: "Lap Bending",
                        value: false,
                    },
                ],
            },
            {
                name: "Carotid Endarterectomy",
                value: false,
            },
            {
                name: "Gallbladder (Cholecystectomy)",
                value: false,
            },
            {
                name: "Hysterectomy (Partial or Total)",
                value: false,
            },
            {
                name: "Joint Replacement",
                value: false,
            },
            {
                name: "Nephrectomy",
                value: false,
            },
            {
                name: "Open Heart (Coronary Artery Bypass)",
                value: false,
            },
            {
                name: "Splenectomy",
                value: false,
            },
            {
                name: "Tonsillectomy",
                value: false,
            },
        ];
        this.setupForm();
    }
    setupForm() {
        let pmh = this.SummaryData.summary.pastsurgicalhistory.historyrecords;

        if (pmh && pmh.length > 0) {
            pmh.forEach((item) => {
                this.checklist.forEach((c, i) => {
                    if (item.name === c.name) {
                        c.value = true;

                        if (item.subset && item.subset.length > 0) {
                            if (c.subset && c.subset.length > 0) {
                                item.subset.forEach((isub) => {
                                    c.subset.forEach((csub) => {
                                        if (isub.name === csub.name) {
                                            csub.value = true;
                                        }
                                    });
                                });
                            }
                        }
                    }
                });
            });
        }
        if (this.SummaryData.summary.pastsurgicalhistory.other && this.SummaryData.summary.pastsurgicalhistory.other.trim().length > 0) {
            this.others = this.SummaryData.summary.pastsurgicalhistory.other;
        }
    }

    isChecklistValid(): boolean {
        let isValid = true;
        this.checklist.forEach((item) => {
            if (item.value === true) {
                if (item.subset && item.subset.length > 0) {
                    let selectedSub = item.subset.filter((i) => i.value === true);
                    if (selectedSub.length === 0) {
                        isValid = false;
                    }
                }
            }
        });

        if (!isValid) {
            this.error = "Please make sure sub-categories are also selected.";
        }

        return isValid;
    }

    getSelectedData() {
        let selectedData = [];

        this.checklist.forEach((item) => {
            if (item.value === true) {
                let i = item;

                if (item.subset) {
                    let s = [];

                    item.subset.forEach((sub) => {
                        if (sub.value === true) {
                            s.push(sub);
                        }
                    });

                    i.subset = s;
                }

                selectedData.push(i);
            }
        });
        return selectedData;
    }

    public onSave() {
        if (this.isChecklistValid()) {
            this.SummaryData.summary.pastsurgicalhistory = { historyrecords: this.getSelectedData() };

            if (this.others.trim().length > 0) {
                this.SummaryData.summary.pastsurgicalhistory["other"] = this.others;
            }
            this.Response.emit({ success: true, message: "", action: "edit", updatedSummaryData: this.SummaryData.summary });
            this.activeModal.close();
        }
    }
    public onCancel() {
        this.Response.emit({ success: true, message: "", action: "edit", updatedSummaryData: this.SummaryData.summary });
        this.activeModal.close();
    }
}
